

















































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import DatePicker from '@/components/ui/DatePicker.vue'
import { findDashboardFinanceiroErros, findDashboardFinanceiroSeguranca, findDashboardFinanceiroBaixaRetroativa, findTotalizador } from '@/api/titulos'
import { DashboardFinanceiroBaixaRetroativa } from '@/models/financeiro/Titulo'
import { DataOptions } from 'vuetify'
import { dateToPtBrFormat, dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component({
	components: {
		SeletorDeLojas,
		DatePicker,
	},
})
export default class DashboardFinanceiro extends Vue {
	filtro = {
		loja: null as string | null,
		dataInicio: null as string | null,
		dataFim: null as string | null,
	}

	carregando = false
	carregandoErros = false
	carregandoSeguranca = false
	buscaRealizada = false

	totalTitulosComErro = 0
	totalDesatualizados = 0
	totalTitulosBase = 0

	totalPagosInsuficientes = 0
	totalAbertosExcedentes = 0
	totalTitulosSeguranca = 0

	carregandoBaixaRetroativa = false
	totalBaixaRetroativa = 0
	titulosBaixaRetroativa: DashboardFinanceiroBaixaRetroativa[] = []
	paginacaoBaixaRetroativa: DataOptions = {
		page: 1,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	headersBaixaRetroativa = [
		{ text: 'Número/Série/Parcela', value: 'numeroSerieParcela' },
		{ text: 'Situação', value: 'situacao' },
		{ text: 'Valor', value: 'valorFormatado' },
		{ text: 'Valor Atualizado', value: 'valorAtualizadoFormatado' },
		{ text: 'Vencimento', value: 'dataDeVencimentoFormatada' },
		{ text: 'Pagamento Informado', value: 'pagamentoInformadoEmFormatado' },
		{ text: 'Baixa Registrada', value: 'baixaRegistradaEmFormatada' },
		{ text: 'Dias Retroatividade', value: 'diasDeRetroatividade' },
		{ text: 'Total Pago', value: 'totalPagoNoTituloFormatado' },
	]

	totalEntrada = 0
	totalPago = 0
	totalEmAberto = 0
	totalInadimplente = 0
	totalJuros = 0
	totalMulta = 0

	get temAcessoIrrestrito() {
		return UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	get porcentagemDesatualizados(): string {
		if (this.totalTitulosBase === 0) return '0.00'
		return ((this.totalDesatualizados / this.totalTitulosBase) * 100).toFixed(2)
	}

	get porcentagemPagosInsuficientes(): string {
		if (this.totalTitulosSeguranca === 0) return '0.00'
		return ((this.totalPagosInsuficientes / this.totalTitulosSeguranca) * 100).toFixed(2)
	}

	get porcentagemAbertosExcedentes(): string {
		if (this.totalTitulosSeguranca === 0) return '0.00'
		return ((this.totalAbertosExcedentes / this.totalTitulosSeguranca) * 100).toFixed(2)
	}

	get porcentagemSaudavel(): string {
		if (this.totalTitulosSeguranca === 0) return '0.00'
		const inconsistentes = this.totalPagosInsuficientes + this.totalAbertosExcedentes
		return (((this.totalTitulosSeguranca - inconsistentes) / this.totalTitulosSeguranca) * 100).toFixed(2)
	}

	get chartSegurancaSeries(): number[] {
		const saudaveis = Math.max(0, this.totalTitulosSeguranca - this.totalPagosInsuficientes - this.totalAbertosExcedentes)
		return [saudaveis, this.totalPagosInsuficientes, this.totalAbertosExcedentes]
	}

	get chartSegurancaOptions() {
		return {
			labels: ['Saudáveis', 'Pagos Insuficientes', 'Abertos Excedentes'],
			colors: ['#2e7d32', '#e64a19', '#6a1b9a'],
			legend: { position: 'bottom' },
			dataLabels: {
				formatter: (val: number) => val.toFixed(1) + '%',
			},
			tooltip: {
				y: {
					formatter: (val: number) => `${val} títulos`,
				},
			},
		}
	}

	get chartSegurancaBarSeries() {
		return [
			{
				name: 'Títulos',
				data: [this.totalPagosInsuficientes, this.totalAbertosExcedentes],
			},
		]
	}

	get chartSegurancaBarOptions() {
		return {
			chart: { toolbar: { show: false } },
			xaxis: {
				categories: ['Pagos c/ Valor Insuficiente', 'Abertos c/ Valor Excedente'],
			},
			colors: ['#e64a19', '#6a1b9a'],
			plotOptions: {
				bar: {
					distributed: true,
					borderRadius: 4,
					dataLabels: { position: 'top' },
				},
			},
			legend: { show: false },
			dataLabels: {
				enabled: true,
				formatter: (val: number) => `${val}`,
				offsetY: -20,
				style: { fontSize: '12px', colors: ['#304758'] },
			},
			tooltip: {
				y: {
					formatter: (val: number) => `${val} títulos`,
				},
			},
			yaxis: {
				labels: {
					formatter: (val: number) => `${val}`,
				},
			},
		}
	}

	get cardsFinanceiros() {
		return [
			{
				label: 'Total de Entradas',
				valor: this.totalEntrada,
				icone: 'mdi-cash-plus',
				cor: '#1976d2',
			},
			{
				label: 'Total Pago',
				valor: this.totalPago,
				icone: 'mdi-check-circle-outline',
				cor: '#4caf50',
			},
			{
				label: 'Total em Aberto',
				valor: this.totalEmAberto,
				icone: 'mdi-clock-outline',
				cor: '#ff9800',
			},
			{
				label: 'Total Inadimplente',
				valor: this.totalInadimplente,
				icone: 'mdi-alert-outline',
				cor: '#f44336',
			},
			{
				label: 'Lucro em Juros',
				valor: this.totalJuros,
				icone: 'mdi-percent',
				cor: '#9c27b0',
			},
			{
				label: 'Lucro em Multa',
				valor: this.totalMulta,
				icone: 'mdi-gavel',
				cor: '#795548',
			},
		]
	}

	get chartPieSeries(): number[] {
		return [this.totalPago, this.totalEmAberto, this.totalInadimplente]
	}

	get chartPieOptions() {
		return {
			labels: ['Pago', 'Em Aberto', 'Inadimplente'],
			colors: ['#4caf50', '#ff9800', '#f44336'],
			legend: { position: 'bottom' },
			dataLabels: {
				formatter: (val: number) => val.toFixed(1) + '%',
			},
			tooltip: {
				y: {
					formatter: (val: number) => this.formatarMoeda(val),
				},
			},
		}
	}

	get chartBarSeries() {
		return [
			{
				name: 'Valor',
				data: [this.totalEntrada, this.totalPago, this.totalEmAberto, this.totalInadimplente, this.totalJuros, this.totalMulta],
			},
		]
	}

	get chartBarOptions() {
		return {
			chart: { toolbar: { show: false } },
			xaxis: {
				categories: ['Entradas', 'Pago', 'Em Aberto', 'Inadimplente', 'Juros', 'Multa'],
			},
			colors: ['#1976d2', '#4caf50', '#ff9800', '#f44336', '#9c27b0', '#795548'],
			plotOptions: {
				bar: {
					distributed: true,
					borderRadius: 4,
				},
			},
			legend: { show: false },
			dataLabels: { enabled: false },
			tooltip: {
				y: {
					formatter: (val: number) => this.formatarMoeda(val),
				},
			},
			yaxis: {
				labels: {
					formatter: (val: number) => this.formatarMoeda(val),
				},
			},
		}
	}

	get itensFormatadosBaixaRetroativa() {
		return this.titulosBaixaRetroativa.map(titulo => ({
			...titulo,
			numeroSerieParcela: `${titulo.numero}/${titulo.serie}/${titulo.parcela}`,
			valorFormatado: this.formatarMoeda(titulo.valor),
			valorAtualizadoFormatado: this.formatarMoeda(titulo.valorAtualizado),
			dataDeVencimentoFormatada: titulo.dataDeVencimento ? dateToPtBrFormat(titulo.dataDeVencimento) : '-',
			pagamentoInformadoEmFormatado: titulo.pagamentoInformadoEm ? dateTimeToPtBrFormat(titulo.pagamentoInformadoEm) : '-',
			baixaRegistradaEmFormatada: titulo.baixaRegistradaEm ? dateTimeToPtBrFormat(titulo.baixaRegistradaEm) : '-',
			totalPagoNoTituloFormatado: this.formatarMoeda(titulo.totalPagoNoTitulo),
		}))
	}

	async carregarDadosDeBaixaRetroativa(lojaId?: string | null) {
		this.carregandoBaixaRetroativa = true
		try {
			const params: Record<string, any> = {
				page: this.paginacaoBaixaRetroativa.page - 1,
				size: this.paginacaoBaixaRetroativa.itemsPerPage,
			}
			if (lojaId) {
				params.lojaId = lojaId
			}
			const res = await findDashboardFinanceiroBaixaRetroativa(params)
			this.titulosBaixaRetroativa = res.content
			this.totalBaixaRetroativa = res.totalElements
		} catch (e) {
			AlertModule.setError("Erro ao buscar dados de baixa retroativa: " + e)
		} finally {
			this.carregandoBaixaRetroativa = false
		}
	}

	@Watch('paginacaoBaixaRetroativa', { deep: true })
	onChangePaginacaoBaixaRetroativa() {
		if (this.buscaRealizada) {
			this.carregarDadosDeBaixaRetroativa(this.filtro.loja)
		}
	}

	async carregarDadosDeErro(lojaId?: string | null) {
		this.carregandoErros = true
		try {
			const res = await findDashboardFinanceiroErros(lojaId ? { lojaId } : undefined)
			this.totalTitulosComErro = res.totalComErro
			this.totalDesatualizados = res.totalDesatualizados
			this.totalTitulosBase = res.totalTitulos
		} catch (e){
			AlertModule.setError("Erro ao buscar dados de titulos: " + e)
		} finally {
			this.carregandoErros = false
		}
	}

	async carregarDadosDeSeguranca(lojaId?: string | null) {
		this.carregandoSeguranca = true
		try {
			const res = await findDashboardFinanceiroSeguranca(lojaId ? { lojaId } : undefined)
			this.totalPagosInsuficientes = res.totalPagosInsuficientes
			this.totalAbertosExcedentes = res.totalAbertosExcedentes
			this.totalTitulosSeguranca = res.totalTitulos
		} catch (e) {
			AlertModule.setError("Erro ao buscar dados de segurança: " + e)
		} finally {
			this.carregandoSeguranca = false
		}
	}

	async buscar() {
		this.carregando = true
		this.buscaRealizada = false
		try {
			const params: Record<string, any> = {
				fluxo: 'Entrada',
			}

			if (this.filtro.loja) {
				params.loja = this.filtro.loja
			}
			if (this.filtro.dataInicio) {
				params.dataInicioPeriodo = this.filtro.dataInicio
			}
			if (this.filtro.dataFim) {
				params.dataFimPeriodo = this.filtro.dataFim
			}

			const [totalizador, totalizadorPago, totalizadorAberto, totalizadorInadimplente] = await Promise.all([
				findTotalizador(params),
				findTotalizador({ ...params, situacaoDoTitulo: 'Pago' }),
				findTotalizador({ ...params, situacaoDoTitulo: 'Aberto' }),
				findTotalizador({ ...params, situacaoDoTitulo: 'Aberto', inadimplente: true }),
			])
			this.carregarDadosDeErro(this.filtro.loja)
			this.carregarDadosDeSeguranca(this.filtro.loja)
			this.paginacaoBaixaRetroativa.page = 1
			this.carregarDadosDeBaixaRetroativa(this.filtro.loja)

			this.totalEntrada = totalizador.valor || 0
			this.totalPago = totalizadorPago.totalPago || totalizadorPago.valor || 0
			this.totalEmAberto = totalizadorAberto.valor || 0
			this.totalInadimplente = totalizadorInadimplente.valor || 0
			this.totalJuros = (totalizador.totalPagoEmJuros || 0)
			this.totalMulta = (totalizador.totalPagoEmMulta || 0)

			this.buscaRealizada = true
		} catch (e: any) {
			this.$emit('erro', e?.message || 'Erro ao carregar dados financeiros.')
		} finally {
			this.carregando = false
		}
	}

	formatarMoeda(valor: number): string {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(valor || 0)
	}
}
